import { NodeElement } from './node-element';

export class NodeElementList extends NodeElement {
    public isNodeElementList = true; // bug in typescript (instanceof doesn't work in this case
}
